import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Estado } from "../../../_models/estado";
import { Canal } from "../../../_models/canal";
import { CanalRestriccionGestionEstado } from "../../../_models/canal-restriccion-gestion-estado";
import { NavService } from "../../../_services/_nav.service";
import { SelectItem } from "primeng/api";
import { forkJoin } from "rxjs";
import { EstadoService } from "../../../_services/estado.service";
import { CanalRestriccionGestionEstadoService } from "../../../_services/canal-restriccion-gestion-estado.service";

@Component({
  selector: "app-canales-restricciones-gestion-estados",
  templateUrl: "./canales-restricciones-gestion-estados.component.html",
  styleUrls: ["./canales-restricciones-gestion-estados.component.css"],
})
export class CanalesRestriccionesGestionEstadosComponent implements OnInit {
  @Input() esDetalle: boolean;
  @Input() canal: Canal;

  cargando = true;
  submitted = false;
  guardando = false;
  formulario: FormGroup;
  listaEstadosTodos: Estado[] = [];
  listaEstados: SelectItem[] = [];
  columnas: any[] = [];
  lisCanalesRestriccionesGestionXEstados: CanalRestriccionGestionEstado[] = [];

  constructor(
    private fb: FormBuilder,
    private navServicio: NavService,
    private estadoService: EstadoService,
    private canalRestriccionGestionEstadoService: CanalRestriccionGestionEstadoService
  ) {}

  ngOnInit() {
    this.listaEstadosTodos = [];
    this.setearColumnas();
    forkJoin(this.estadoService.listadoHabilitados()).subscribe(
      ([listaEstados]) => {
        this.listaEstadosTodos = listaEstados;
        this.cargarFormulario();
        this.cargaInicial();
      }
    );
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idsEstados: [null, [Validators.required]],
    });
  }

  /* columnas del data table */
  setearColumnas() {
    this.columnas = [
      {
        field: "codigoEstado",
        header: this.navServicio.buscarMensaje("CANALES.LBL_CODIGO"),
        sort: true,
      },
      {
        field: "estado",
        header: this.navServicio.buscarMensaje("CANALES.LBL_ESTADO"),
        sort: true,
      },
      {
        field: "perfilRiesgo",
        header: this.navServicio.buscarMensaje("LBL_HABILITADO"),
        sort: false,
      },
    ];
  }

  /* carga incial de datos */
  cargaInicial() {
    this.listaEstados = [];
    this.lisCanalesRestriccionesGestionXEstados = [];

    forkJoin(
      this.canalRestriccionGestionEstadoService.obtenerPorCanal(
        this.canal.idCanal
      )
    ).subscribe(([lisCanalesRestriccionesGestionXEstados]) => {
      this.lisCanalesRestriccionesGestionXEstados = lisCanalesRestriccionesGestionXEstados;
      this.validarLista();
      this.cargando = false;
      this.guardando = false;
    });
  }

  /* validar y llenar las listas necesarias */
  validarLista() {
    this.listaEstadosTodos.map((x) => {
      if (
        !this.lisCanalesRestriccionesGestionXEstados.find(
          (s) => s.idEstado === x.idEstado
        )
      ) {
        this.listaEstados.push({ label: x.nombreEstado, value: x.idEstado });
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      this.guardando = true;
      let registros: CanalRestriccionGestionEstado[] = [];
      this.formulario.value.idsEstados.map((x) => {
        let obj = {} as CanalRestriccionGestionEstado;
        obj.idCanal = this.canal.idCanal;
        obj.idEstado = x;
        obj.indicadorHabilitado = true;
        registros.push(obj);
      });
      this.canalRestriccionGestionEstadoService.bulk(registros).subscribe(
        (res) => {
          this.navServicio.setMesage(1);
          this.formulario.reset();
          this.submitted = false;
          this.cargaInicial();
        },
        (error) => {
          this.navServicio.setMesage(3);
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
        }
      );
    }
  }

  /* controls del formulario */
  get f() {
    return this.formulario.controls;
  }

  /* inhabilitar el registro */
  habilitarInhabilitar(row: CanalRestriccionGestionEstado) {
    this.guardando = true;
    this.canalRestriccionGestionEstadoService.actualizar(row).subscribe(
      (res) => {
        this.navServicio.setMesage(2);
        this.formulario.reset();
        this.submitted = false;
        this.cargaInicial();
      },
      (error) => {
        this.navServicio.setMesage(3);
        this.formulario.reset();
        this.submitted = false;
        this.guardando = false;
      }
    );
  }
}
